import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=f3988810&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=f3988810&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3988810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3988810')) {
      api.createRecord('f3988810', component.options)
    } else {
      api.reload('f3988810', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=f3988810&scoped=true&", function () {
      api.rerender('f3988810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-85aCiZ4xA6Rje/JS/comp/Paginate.vue"
export default component.exports